import { useState } from "react";

import { Modal } from "@/ui";
import { ResearchTag } from "./research-tag";

export const ResearchDiagram = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div className="flex justify-center rounded-card bg-surface-sunken px-4 pt-12 sm:px-8 md:p-16">
        <img
          alt=""
          className="rounded-card bg-product-media md:hidden"
          src="/assets/images/guided-rest.png"
        />

        <div className="hidden items-center justify-center md:flex">
          <img
            alt=""
            className="rounded-card bg-product-media"
            src="/assets/images/guided-comfort.png"
          />

          <div className="flex flex-col gap-4">
            <ResearchTag title="Safety & Efficacy Trials">
              Conducted by 3rd Party{" "}
              <a
                className="underline"
                href="https://www.citruslabs.com/"
                rel="noreferrer"
                target="_blank"
              >
                Citruslabs
              </a>
            </ResearchTag>

            <ResearchTag title="Quality of Life Impact Surveys">
              Using Standardized{" "}
              <button
                className="cursor-pointer underline"
                onClick={() => {
                  return setIsOpen(true);
                }}
              >
                PROMIS & PIO Metrics
              </button>
            </ResearchTag>

            <ResearchTag title="Cannabis Research Analyses">
              Updated Quarterly by Our Clinical Team
            </ResearchTag>

            <ResearchTag title="Clinical Team Experience">
              <p>Over 20,000 Patient Interactions</p>
              <p>Over 20 Peer Reviewed Studies</p>
            </ResearchTag>
          </div>
        </div>
      </div>

      <Modal
        body={
          <div className="flex flex-col gap-4">
            <p>
              PROMIS metrics are a set of short, standardized, and validated patient-reported
              measures used to assess physical, mental, and social health, as well as quality of
              life.
            </p>
            <p>
              Personally Important Outcome (PIO) metrics are personalized measures focused on the
              activities that your symptoms are keeping you from performing and/or enjoying as much
              as you’d like. For example, if you have a sore knee that limits your ability to walk
              your dog, being able to walk your dog with less pain/more often is a Personally
              Important Outcome.
            </p>
            <p>
              We use PROMIS and PIO metrics to inform your care plan and better understand your
              progress, and to further improve our care plan experience and products for all.
            </p>
          </div>
        }
        closeModal={() => {
          return setIsOpen(false);
        }}
        isOpen={isOpen}
        title="PROMIS & PIO Metrics"
      />
    </>
  );
};
